
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/step/checkout/[id]",
      function () {
        return require("private-next-pages/android/step/checkout/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/step/checkout/[id]"])
      });
    }
  